"use strict";
var Observable_1 = require('../../Observable');
var interval_1 = require('../../observable/interval');
Observable_1.Observable.interval = interval_1.interval;
//# sourceMappingURL=interval.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/observable/interval.js